import { BackupInfo, BackupSlot, Image, Server } from '../ApiModel';

// Daily backups retained by the enable_backups server action; mirrors GuestApiService.AssumedEnableDailyBackups.
export const AssumedEnableDailyBackups = 2;

interface BackupImageOverrides {
    type: 'backup';
    backup_info: BackupInfo;
    created_at: string;
}

export type BackupImage = Omit<Image, keyof BackupImageOverrides> & BackupImageOverrides;

export function isBackupImage(image: Image): image is BackupImage {
    return image.type === 'backup';
}

export function backupImages(images: Image[]): BackupImage[] {
    return images.filter(isBackupImage);
}

export function backupCountByType(backups: BackupImage[], type: BackupSlot) {
    return backups.filter((b) => b.backup_info.type === type).length;
}

export function getBackupDisk(backup: BackupImage, id: number) {
    return backup.backup_info.backup_disks.find((d) => d.id === id);
}

export function numberOfBackups(backupConfig: {
    daily_backups?: number;
    weekly_backups?: number;
    monthly_backups?: number;
}) {
    return (backupConfig.daily_backups ?? 0) + (backupConfig.weekly_backups ?? 0) + (backupConfig.monthly_backups ?? 0);
}

export function areBackupsEnabled(server: Server) {
    return numberOfBackups(server.selected_size_options ?? {}) > 0;
}

/**
 * Returns true if a backup can be restored. ISOs and unavailable backups cannot be restored.
 * Note: min_disk_size validation is enforced server-side. We still list oversized backups
 * so the customer can learn why restoration fails if they attempt it.
 */
export function canRestoreBackup(backup: BackupImage): boolean {
    return backup.status === 'available' && !backup.backup_info.iso;
}
